let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8LUW6")).then(() => parcelRequire('1uqxU'));